<template>
  <section id="section-gallery" class="itinerary-gallery">
    <MediaGallery
      v-if="store.data?.itinerary"
      :featureImages="store.data.itinerary.images"
      :videoUrl="store.data.itinerary.videoUrl"
      :manage-photos="openImageUploadDialog"
    >
      <template #manage-photos v-if="editable">
        <Button
          class="add-image-button"
          :class="{
            'small-btn-padding':
              store.data?.itinerary?.images?.length === 3 || store.data?.itinerary?.images?.length === 4,
          }"
          color="green"
          invert
          @click="openImageUploadDialog"
          @click.stop.prevent
          :disabled="loading"
          >Manage photos</Button
        >
      </template>
    </MediaGallery>
    <ImageUploadDialog
      v-if="isImageUploadOpen"
      multiple
      title="Add photos"
      confirmButtonText="Save changes"
      cancelButtonText="Cancel"
      :isImageUploadOpen="isImageUploadOpen"
      @close="isImageUploadOpen = false"
      @save="onFileSubmitted"
      :images="store.data?.itinerary?.images"
      has-cover-image
      :loading="loading"
    />
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import MediaGallery from '@/modules/MediaGallery/MediaGallery.vue'
import ImageUploadDialog from '@/modules/Itinerary/Components/ImageUploadDialog.vue'
import Button from '@/components/Theme2/Button.vue'
import { useTypedItineraryStore } from '../../stores/typed'
import { Product } from '../../models'

const props = defineProps<{
  editable: boolean
}>()

const store = useTypedItineraryStore<Product>()
const loading = ref(false)

const isImageUploadOpen = ref(false)

const openImageUploadDialog = () => {
  isImageUploadOpen.value = true
}

const onFileSubmitted = async ({
  files,
  imageSlugs,
  imageOrder,
}: {
  files: File[]
  imageSlugs: string[]
  imageOrder: string[]
}) => {
  if (!store.data || !props.editable) return

  loading.value = true

  const formData = new FormData()
  files.forEach(file => {
    formData.append('cover_images[]', file)
  })

  if (imageSlugs.length > 0) {
    imageSlugs.forEach(slug => {
      formData.append('existing_cover_image_slugs[]', slug)
    })
  } else {
    formData.append('existing_cover_image_slugs[]', '')
  }

  imageOrder.forEach(entry => {
    formData.append('image_order[]', entry)
  })

  try {
    await store.updateItineraryImages({ productId: store.data.id, formData })
    isImageUploadOpen.value = false
  } catch (error) {
    console.error(error)
  } finally {
    loading.value = false
  }
}
</script>

<style lang="scss" scoped>
.itinerary-gallery {
  position: relative;

  .add-image-button-container {
    position: absolute;
    top: 0;
    right: 0;
  }

  .add-image-button {
    position: absolute;
    top: 1rem;
    right: 1rem;

    @include mobile {
      top: 0.5rem;
      right: 0.5rem;

      &.small-btn-padding {
        padding: 8px 12px;
      }
    }
  }
}
</style>
